const divModalEquipService = {
  text: 'Seleccione un Sitio'
};

export default divModalEquipService;
